import request from '@/utils/request'

// 查询商铺下的所有建议
export function list(data) {
  return request({
    url: '/shop/compliance/compadviseinfo/list',
    method: 'get',
    params: data
  })
}

// ops查看列表
export function page(data) {
  return request({
    url: '/shop/compliance/compadviseinfo/page',
    method: 'get',
    params: data
  })
}

// 新增建议
export function insert(data) {
  return request({
    url: '/shop/compliance/compadviseinfo/insert',
    method: 'post',
    data
  })
}

// 投诉建议详情
export function adviseInfo(id) {
  return request({
    url: `/shop/compliance/compadviseinfo/info/${id}`,
    method: 'get',
  })
}

// 回复投诉建议
export function adviseReply(data) {
  return request({
    url: `/shop/compliance/compadviseinfo/reply`,
    method: 'post',
    data
  })
}

// 查询投诉建议角标
export function cornerMark(data) {
  return request({
    url: '/shop/compliance/compadviseinfo/queryCornerMark',
    method: 'get',
    params: data
  })
}
